import { useDispatch, useSelector } from "react-redux";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import React, { useEffect } from "react";
import {
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
  Grid,
  Avatar,
  Container,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ProfileOptionsForm from "./profileOptions";
import { useTranslation } from "react-i18next";
import AddressForm from "./addressForm";
import ContactForm from "./contactForm";
import { getUserEntity } from "../../../redux/features/authSlice";
import FormModal from "../../../components/FormModal/FormModal";
import ManageAddresses from "../../../components/ManageAddresses";
import ManageContacts from "../../../components/ManageContacts";
import Document from "./Document";
import { green } from "@mui/material/colors";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { GetProfileImages } from "../../../Containers/DocumentDetails/slice";
import {
  documentFileUpload,
  setBannerUri,
  setProfileUri,
  addUserDetail,
  deleteAddress,
} from "../../../Containers/OnBoarding/slice";
import { useSnackbar } from "notistack";
import { getDocuments } from "../../../Containers/DocumentDetails/slice";
import DocumentDetails from "../../../Containers/DocumentDetails";
import UploadDocument from "../../../Containers/UploadDocuments";
import ConfirmDialog from "../../../components/ConfirmDialog";
import Modal from "../../../components/Modal";
import { RegistrationStatus } from "../../../common/enum";

const UserProfile = ({ t }) => {
  const dispatch = useDispatch();
  const COVER_URL = "/static/illustrations/illustration_default_banner.jpg";
  const AVATAR_URL = "/static/illustrations/illustration_defaultavatar.png";
  const { auth, onBoarding } = useSelector((state) => state);
  const {
    address,
    contact,
    entity,
    registeredEmail,

    userType,
    businessRegistration,
    mandatedStatement,
  } = auth.profile || {};

  const { bannerUri, profileUri } = onBoarding || {};

  const { userId, status ,managerName} = auth.user || {};

  const { enqueueSnackbar } = useSnackbar();

  const [isUploadDocument, setIsUploadDocument] = React.useState(false);
  const [profilePercentage, setProfilePercentage] = React.useState(0);
  const [bannerPercentage, setBannerPercentage] = React.useState(0);
  const [expandedAddresses, setExpandedAddresses] = React.useState(false);
  const [confirmationDialog, setConfirmationDialog] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [modelContent, setModelContent] = React.useState("");
  const [deleteAddressId, setDeleteAddressId] = React.useState("");
  const [entitybanneruri, setentitybanneruri] = React.useState("");
  const [profilepictureuri, setprofilepictureuri] = React.useState("");

  const setConfirmationValue = (val) => {
    setConfirmationDialog(val);
  };

  const setDeleteAddressIdValue = (val) => {
    setDeleteAddressId(val);
  };

  const setModelContentValue = (val) => {
    setModelContent(val);
  };

  const setModalOpenValue = (val) => {
    setModalOpen(val);
  };

  const primaryContact = React.useMemo(() => {
    if (contact.length > 0) {
      return contact.find((item) => item.contactId === entity.contactId);
    }
    return {};
  }, [contact, entity]);

  useEffect(() => {
    dispatch(getUserEntity(userId));
    const data = {
      entityId: entity.entityId,
      limit: 10,
      offset: 0,
    };
    dispatch(getDocuments(data));
  }, [dispatch]);

  useEffect(() => {
  if (!entity) return;

  dispatch(setBannerUri(""));
  dispatch(setProfileUri(""));

  // Banner image
  if (entity.bannerImage && entity.bannerImage !== "string") {
    dispatch(GetProfileImages(entity.bannerImage))
      .unwrap()
      .then((response) => {
        if(response.isActive != null){
            setentitybanneruri(response.isActive);
          }else{
            setentitybanneruri(COVER_URL);
          }
      })
      .catch((err) => {
        console.warn("Erro ao carregar banner image:", err);
      });
  }

  // Profile picture
  if (entity.profilePicture && entity.profilePicture !== "string") {
    dispatch(GetProfileImages(entity.profilePicture))
      .unwrap()
      .then((response) => {
        if(response.isActive != null){
            setprofilepictureuri(response.isActive);
          }else{
            setprofilepictureuri(AVATAR_URL);
          }
      })
      .catch((err) => {
        console.warn("Erro ao carregar profile picture:", err);
      });
  }
}, [entity, dispatch]);

  const [id] = userId.split("-");
  const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(2),
    // textAlign: 'left',
    color: theme.palette.text.secondary,
  }));

  const onUploadProfileProgress = (progressEvent) => {
    const { loaded, total } = progressEvent;
    let percent = Math.floor((loaded * 100) / total);
    if (percent < 100) {
      setProfilePercentage(percent);
    }
  };

  const uploadBanner = React.useCallback((e) => {
    const data = new FormData();
    data.append("file", e.target.files[0]);
    const onUploadProgress = onUploadProfileProgress;
    dispatch(documentFileUpload({ data, onUploadProgress }))
      .unwrap()
      .then((res) => {
        // dispatch(setBannerUri(res.fileName));
        const userDetails = {
          entityName: entity.entityName,
          entityId: userId,
          entityType: entity.entityType, //entityType //profileOption
          nic: entity.nic,
          websiteUrl: entity.websiteUrl,
          profilePicture: entity.profilePicture,
          bannerImage: res.fileName,
          tin: entity.tin,
          occupation: entity.occupation,
          isGroupEntity: entity.isGroupEntity, // entityTypeOption
          areaOfActivity: entity.areaOfActivity, // activityOption
          isParentEntity: entity.isParentEntity,
          cae: entity.cae,
          parentEntityId: entity.parentEntityId,
          contactId: entity.contactId,
          entityAddressId: entity.entityAddressId,
        };
        dispatch(addUserDetail(userDetails))
          .unwrap()
          .then((response) => {
            dispatch(GetProfileImages(response.entity.bannerImage))
             .unwrap()
          .then((response) => {
              dispatch(setBannerUri(response.isActive));
              enqueueSnackbar({
                    message: t("imageUpdate"),
                    variant: "success",
                  });
          })
    
           
          });
        setBannerPercentage(100);
        setTimeout(() => {
          setBannerPercentage(0);
        }, 1000);
      })
      .catch((error) => {
       // console.log(error);
      });
  }, []);

  const uploadProfileImage = React.useCallback((e) => {
    const data = new FormData();
    data.append("file", e.target.files[0]);
    const onUploadProgress = onUploadProfileProgress;
    dispatch(documentFileUpload({ data, onUploadProgress }))
      .unwrap()
      .then((res) => {
        
        const userDetails = {
          entityName: entity.entityName,
          entityId: userId,
          entityType: entity.entityType, //entityType //profileOption
          nic: entity.nic,
          websiteUrl: entity.websiteUrl,
          profilePicture: res.fileName,
          bannerImage: entity.bannerImage,
          tin: entity.tin,
          occupation: entity.occupation,
          isGroupEntity: entity.isGroupEntity, // entityTypeOption
          areaOfActivity: entity.areaOfActivity, // activityOption
          isParentEntity: entity.isParentEntity,
          cae: entity.cae,
          parentEntityId: entity.parentEntityId,
          contactId: entity.contactId,
          entityAddressId: entity.entityAddressId,
        };
        dispatch(addUserDetail(userDetails))
          .unwrap()
          .then((response) => {
            dispatch(GetProfileImages(response.entity.profilePicture))
             .unwrap()
          .then((response) => {
              dispatch(setProfileUri(response.isActive));
              enqueueSnackbar({
                    message: t("imageUpdate"),
                    variant: "success",
                  });
          })
          });
        setProfilePercentage(100);
        setTimeout(() => {
          setProfilePercentage(0);
        }, 1000);
      })
      .catch((error) => {
       // console.log(error);
      });
  }, []);

  const onConfirm = () => {
    if (deleteAddressId) {
      dispatch(deleteAddress(deleteAddressId))
        .unwrap()
        .then((res) => {
          dispatch(getUserEntity(entity.entityId));
          setConfirmationValue(false);
          enqueueSnackbar({
            message: t("successfullyAddressDeleted"),
            variant: "success",
          });
          setDeleteAddressId("");
        })
        .catch((error) => {
          enqueueSnackbar({
            message: t("someThingWentWrong"),
            variant: "error",
          });
        });
    }
  };

  return (
    <>
      <Paper variant="outlined">
        <Container
          sx={{
            p: "30px",
          }}
        >
          <Stack spacing={2}>
            {managerName == null &&<Item key="avatar">
              <Grid container>
                <Grid
                  item
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    paddingBottom: "30px",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundImage: `url(${
                      bannerUri.length > 0
                        ? bannerUri
                        : entity?.bannerImage === "string" ||
                          entity?.bannerImage === null
                        ? COVER_URL
                        : entitybanneruri
                    })`,
                  }}
                >
                  <Button
                    aria-label="upload picture"
                    component="label"
                    sx={{
                      color: "#fff",
                      padding: "6px 16px !important",
                      fontWeight: 500,
                      textTransform: "none",
                      transform: "translate(-50%, -50%)",
                      backgroundColor: "#212529 !important",
                      top: "10%",
                      left: "49%",
                    }}
                    startIcon={<CloudUploadOutlinedIcon />}
                    disabled={
                      status === RegistrationStatus.inActive ||
                      status === RegistrationStatus.inAtivo ||
                      status === RegistrationStatus.revoked
                    }
                  >
                    <input
                      hidden
                      accept="image/png, image/jpg, image/jpeg"
                      type="file"
                      onChange={uploadBanner}
                    />
                    Definir a imagem do banner
                  </Button>
                  <Avatar
                    className="fotoperfil"
                    alt={entity?.entityName}
                    src={
                      profileUri.length > 0
                        ? profileUri
                        : entity?.profilePicture === "string" ||
                          entity?.profilePicture === null
                        ? AVATAR_URL
                        : profilepictureuri
                    }
                    sx={{
                      width: 100,
                      backgroundSize: "cover",
                      height: 100,
                      bgcolor: green[500],
                      "& img": {
                        height:
                          entity?.profilePicture === "string" ||
                          entity?.profilePicture === null
                            ? "100%"
                            : "100%",
                        width:
                          entity?.profilePicture === "string" ||
                          entity?.profilePicture === null
                            ? "100%"
                            : "100%",
                      },
                    }}
                  />
                  <Button
                    aria-label="upload picture"
                    component="label"
                    sx={{
                      color: "#fff",
                      padding: "6px 7px !important",
                      fontWeight: 500,
                      textTransform: "none",
                      minWidth: 0,
                      "& .MuiButton-startIcon": {
                        margin: "0px !important",
                      },
                      left: "2.1%",
                      bottom: "25%",
                      transform: "translate(-50%, -50%)",
                      backgroundColor: "#212529b0 !important",
                      borderRadius: "50%",
                      zIndex: 10,
                    }}
                    disabled={
                      status === RegistrationStatus.inActive ||
                      status === RegistrationStatus.inAtivo ||
                      status === RegistrationStatus.revoked
                    }
                    startIcon={<CloudUploadOutlinedIcon />}
                  >
                    <input
                      hidden
                      accept="image/png, image/jpg, image/jpeg"
                      type="file"
                      onChange={uploadProfileImage}
                    />
                  </Button>
                  {/* <Typography
                    variant="h6"
                    sx={{ paddingTop: "10px", color: "white" }}
                  >
                    UserId:{" "}
                    <Typography
                      component="span"
                      variant="body1"
                      sx={{ textTransform: "uppercase" }}
                    >
                      {id}
                    </Typography>
                  </Typography>
                  <Typography
                    variant="h6"
                    fontWeight={"bold"}
                    sx={{ paddingTop: "2px", color: "white" }}
                  >
                    Email:{" "}
                    <Typography component="span" variant="body1">
                      {registeredEmail}
                    </Typography>
                  </Typography> */}
                  <Typography
                    variant="h2"
                    textTransform={"uppercase"}
                    fontSize={24}
                    sx={{ color: "white" }}
                  >
                    {entity?.entityName}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={9}>
                {/* <Typography>{email}</Typography> */}
              </Grid>
            </Item>}
            <Item key="profile1" style={{marginTop: "10px"}}>
              <Accordion sx={{ border: "none", boxShadow: "none" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="h3" style={{fontSize:"26px", fontWeight:"normal"}}>{t("profileOptions")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <ProfileOptionsForm t={t} />
                </AccordionDetails>
              </Accordion>
            </Item>
            <Item key="profile2" style={{marginTop: "8px"}}>
              <Accordion sx={{ border: "none", boxShadow: "none" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="h3" style={{fontSize:"26px", fontWeight:"normal"}}>{t("primaryAddress")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <AddressForm address={address[0]} entity={entity} t={t} />
                </AccordionDetails>
              </Accordion>
            </Item>
            <Item key="profile3" style={{marginTop: "8px"}}>
              <Accordion sx={{ border: "none", boxShadow: "none" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="h3" style={{fontSize:"26px", fontWeight:"normal"}}>{t("contactDetail")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <ContactForm contact={primaryContact} t={t} />
                </AccordionDetails>
              </Accordion>
            </Item>
            {managerName == null && <Item key="profile4" style={{marginTop: "8px"}}>
              <Accordion
                sx={{ border: "none", boxShadow: "none" }}
                expanded={expandedAddresses}
                onChange={() => setExpandedAddresses(!expandedAddresses)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="h3" style={{fontSize:"26px", fontWeight:"normal"}}>{t("addresses")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <ManageAddresses
                    t={t}
                    address={address}
                    setConfirmationDialog={setConfirmationValue}
                    setModalOpen={setModalOpenValue}
                    setModelContent={setModelContentValue}
                    setDeleteAddressId={setDeleteAddressIdValue}
                  />
                </AccordionDetails>
              </Accordion>
            </Item>}
            <Item key="profile5" style={{marginTop: "8px"}}>
              <Accordion sx={{ border: "none", boxShadow: "none" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="h3" style={{fontSize:"26px", fontWeight:"normal"}}>{t("contacts")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <ManageContacts 
                    t={t} 
                    contact={contact} 
                  />
                </AccordionDetails>
              </Accordion>
            </Item>
            {/* <Item key="profile6">
              <Accordion sx={{ border: "none", boxShadow: "none" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography fontSize="26px">{t("document")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {/* <Document
                    t={t}
                    businessRegistration={businessRegistration}
                    mandatedStatement={mandatedStatement}
                  /> 
                  
                  

                  
                </AccordionDetails>
              </Accordion>
              
            </Item> */}
            {entity.isParentEntity && entity.parentEntityId === null && managerName == null && (
              <Paper sx={{ p: 2 }}>
                <Accordion sx={{ border: "none", boxShadow: "none" }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    {" "}
                    <Typography variant="h3" style={{fontSize:"26px", fontWeight:"normal"}}>{t("document")}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                  <Paper
    variant="outlined"
    sx={{
      display: "flex",
      flexDirection: "column",
      p: 1,
    }}
  >
                    {!isUploadDocument && entity.isParentEntity && (
                      <Button
                        variant={"contained"}
                        onClick={() => setIsUploadDocument(true)}
                        sx={{
                          my: 1,
                          left: "0px",
                          borderRadius: "4px",
                          width: "222px"
                        }}
                      >
                        {t("upload")}
                      </Button>
                    )}
                    {!isUploadDocument && (
                      <DocumentDetails
                        componentType={""}
                        entityId={entity?.entityId}
                        t={t}
                      />
                    )}
                    {isUploadDocument && (
                      <UploadDocument
                        setIsUploadDocument={setIsUploadDocument}
                        t={t}
                      />
                    )}
                    </Paper>
                  </AccordionDetails>
                </Accordion>
              </Paper>
            )}
          </Stack>
        </Container>
      </Paper>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpenValue(false)}
        title={t("")}
        content={modelContent}
      />
      <ConfirmDialog
        open={confirmationDialog}
        handleClose={() => setConfirmationDialog(false)}
        title={t("")}
        content={t("deleteAddressContent")}
        onConfirm={onConfirm}
        cancelButtonTitle={t("cancel")}
        confirmButtonTitle={t("confirm")}
      />
    </>
  );
};

export default UserProfile;
